import { request } from '@/common/request';

export interface SecurityProfile {
  id: string | number;
  pwdNeedChange: boolean;
  smsCaptchaEnabled: boolean;
  smsCaptchaExpireSeconds: number;
  firstLogin?: boolean;
  hasPassword?: boolean;
}

export async function getSecurityProfile(token: string): Promise<SecurityProfile> {
  const profile = await request.get<any, SecurityProfile>('/uaa/user/profile/user', {
    headers: { Authorization: token },
  });
  if (
    typeof profile?.pwdNeedChange !== 'boolean' ||
    typeof profile?.smsCaptchaEnabled !== 'boolean' ||
    (profile.smsCaptchaEnabled &&
      (!Number.isFinite(profile.smsCaptchaExpireSeconds) || profile.smsCaptchaExpireSeconds <= 0))
  ) {
    throw new Error('登录安全配置不完整，请联系管理员后重试');
  }
  return profile;
}
export const sendSecuritySms = (token: string) =>
  request.post<any, unknown>('/uaa/user/smsCaptcha', undefined, {
    headers: { Authorization: token },
  });
export const verifySecuritySms = (token: string, captcha: string) =>
  request.post<any, unknown>(
    '/uaa/user/smsCaptcha/verify',
    { captcha },
    {
      headers: { Authorization: token },
    },
  );
